import React, { useState } from 'react'
import { Row, Col, Table, Button, Form, FormControl, ButtonGroup, InputGroup, ListGroup } from 'react-bootstrap'
import { FetchCreateBoutiqueTransaction, FetchReadCustomers, FetchSalutations } from '../../fetcher'
import { ModalComponent } from '../presentational-components/ModalComponent'
import AlertMessage from '../presentational-components/AlertMessage'
import EnumValueTranslations from '../presentational-components/EnumValueTranslations'
import NewSale from './NewSale'
import { Redirect } from 'react-router-dom'
import { useEffect } from 'react'
import { NewCustomer } from './NewCustomer'
import LoadingSpinner from '../presentational-components/LoadingSpinner'


const ContactDetails = ({ setOpenContactDetails, setContactDetails, openAlert, contactIsSet, setContactIsSet, contactDetails }) => {

    const [salutations, setSalutations] = useState([])
    const [contacts, setContacts] = useState([])
    const [selectedContact, setSelectedContact] = useState(null)

    const [createdContactId, setCreatedContactId] = useState(null)

    const [taskName, setTaskName] = useState("Lade Kunden...")
    const controller = new AbortController()
    const signal = controller.signal

    useEffect(() => {
        FetchReadCustomers(setContacts, openAlert, signal, "ContactDetails")
    }, [])

    useEffect(() => {
        console.log("Contacts: ", contacts)
    }, [contacts])

    useEffect(() => {
        FetchSalutations(setSalutations, openAlert)
    }, [])

    useEffect(() => {
        if (createdContactId !== null) setSelectedContact(contacts.find(x => x.Contact.ContactSysId === createdContactId))
    }, [contacts])

    useEffect(() => {
        if (contactIsSet) setSelectedContact(contactDetails) 
    }, [contactIsSet])

    const [showModal, setShowModal] = useState(false)
    const handleOpenModal = () => {
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setShowModal(false)
        FetchReadCustomers(setContacts, openAlert, signal, "ContactDetails")
    }

    const returnToOrder = () => {
        if (selectedContact !== null && selectedContact !== undefined) setContactDetails(selectedContact) 
        console.log("returnToOrder: ", selectedContact)
        setContactIsSet(true)
        setOpenContactDetails(false)
    }

    const openNewCustomer = () => {
        handleOpenModal()
    }

    const [contactFilterInput, setContactFilterInput] = useState("")
    const handleContactFilter = (e) => {
        setContactFilterInput(e.target.value)
    }

    const filterContact = (contact) => {
        let filterInputTemp = contactFilterInput.toLowerCase().split(" ")
        //let filter = filterInputTemp.some(x => contact.Contact.Name.toLowerCase.includes(x) || contact.Contact.Surname.toLowerCase.includes(x) || contact.Contact.Phone.toLowerCase.includes(x) || contact.Contact.Email.toLowerCase.includes(x))
        let filter = filterInputTemp.every(x => contact.Contact.Name.toLowerCase().includes(x)
            || contact.Contact.Surname.toLowerCase().includes(x)
            || contact.Contact.Phone.toLowerCase().includes(x)
            || contact.Contact.Email.toLowerCase().includes(x))

        console.log("filterContact", filterInputTemp, filter)
        return filter
    }

    return (
        <div >
            <h1 className="tablet-center">Kontakt wählen oder hinzufügen</h1>
            <div className="flex-linebreak"></div>

            <div className="tablet-transactions">
                <Table>
                    <thead>
                        <th>{selectedContact !== undefined && selectedContact !== null ? selectedContact.Contact.Name + ", " + selectedContact.Contact.Surname : "Kontakt auswählen"}</th>
                        <th>{selectedContact !== undefined && selectedContact !== null ? selectedContact.Contact.Email : ""}</th>
                        <th>{selectedContact !== undefined && selectedContact !== null ? selectedContact.Contact.Phone : ""}</th>
                        <th>{selectedContact !== undefined && selectedContact !== null ? (selectedContact.Street?? "") + ", " + (selectedContact.HouseNumber?? "") + ", " + (selectedContact.PostalCode?? "") + ", " + (selectedContact.City?? "") : ""}</th>
                    </thead>
                </Table>
                <div>
                    <div className="designerList">
                        <Col className="designer-col">
                            <div className="inline">
                                <FormControl className="globalSearch-booking" as="input" placeholder="Suche Kunde..." value={contactFilterInput} onChange={handleContactFilter}></FormControl>
                            </div>
                            <ListGroup className="listGroup" >
                                {contacts.sort((a, b) => a.Contact.Name.localeCompare(b.Contact.Name)).filter(x => filterContact(x)).map(contact =>
                                    <ListGroup.Item className="listGroup-item" value={contact.Name} action onClick={(e) => setSelectedContact(contact)}
                                        active={selectedContact !== undefined && selectedContact !== null && contact.Contact.ContactSysId === selectedContact.Contact.ContactSysId}>

                                        <Row className="nowrap">
                                            <Col className="dropdown-customer-smallField">{contact.Contact.Name}</Col>
                                            <Col className="dropdown-customer-smallField">{contact.Contact.Surname}</Col>
                                            <Col className="dropdown-customer-smallField">{contact.Contact.Email}</Col>
                                            <Col className="dropdown-customer-smallField">{contact.Contact.Phone}</Col>
                                        </Row>
                                    </ListGroup.Item>
                                )}
                            </ListGroup>
                        </Col>
                    </div>

                    <div className="flex-linebreak"></div>
                    <br />
                </div>

                <div className="inline">
                    <Button variant="secondary" onClick={() => openNewCustomer()}>Neuer Kunde</Button>
                    &nbsp;
                    <Button variant="secondary" onClick={() => returnToOrder()} disabled={selectedContact === null || selectedContact === undefined}>Weiter</Button>
                </div>
                

                <div className="bookingButtons">
                    {/*<Button variant="secondary" onClick={() => { returnToOrder() }}>Zurück</Button>*/}
                    {/*<Button variant="secondary" disabled={number === null || number === 0 ? true : false} onClick={handleSubmit}>Buchen</Button>*/}
                </div>
            </div>

            <ModalComponent handleShow={showModal} handleClose={handleCloseModal}
                modalTitle="Neuen Kunden hinzufügen" modalBody={<NewCustomer openAlert={openAlert} handleCloseModal={handleCloseModal} salutations={salutations.Salutations} setContactId={setCreatedContactId} />} formTitle="create-customer-form" />

            <LoadingSpinner task={taskName} area={"ContactDetails"} />
        </div>
    )
}

export { ContactDetails }